import { default as api } from 'config/frontApiConf';

export const eventRegisterService = async (data) => {
	try {
		let result = await api.post(`/event-register`, data);
		return result;
	} catch (error) {
		return error;
	}
};
